import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CamapignService } from '../../services/campaign.service';
import { Camapign } from '../../interfaces/campaigns.interface';
import { GenericResponseWithTotal } from '../../interfaces/generic.interface';
import { CamapignComponent } from '../camapign/camapign.component';
import { CampaignScansComponent } from '../campaign-scans/campaign-scans.component';

@Component({
  selector: 'app-camapigns',
  standalone: false,
  templateUrl: './camapigns.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./camapigns.component.scss']
})
export class CamapignsComponent implements OnInit {
  campaigns: Camapign[] = [];
  total = 0;
  loading = false;
  error: string | null = null;

  displayedColumns = ['active', 'name', 'valid', 'actions'];

  constructor(
    private campaignService: CamapignService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.load();
  }

  openNew(): void {
    const ref = this.dialog.open(CamapignComponent, {
      width: '90vw',
      maxWidth: '700px',
      maxHeight: '80vh',
      data: { id: null }
    });
    ref.afterClosed().subscribe(saved => {
      if (saved) this.load();
    });
  }

  openScans(c: Camapign): void {
    this.dialog.open(CampaignScansComponent, {
      width: '95vw',
      maxWidth: '1100px',
      maxHeight: '90vh',
      data: { campaign: c }
    });
  }

  openEdit(c: Camapign): void {
    const ref = this.dialog.open(CamapignComponent, {
      width: '90vw',
      maxWidth: '700px',
      maxHeight: '80vh',
      data: { id: c.id }
    });
    ref.afterClosed().subscribe(saved => {
      if (saved) this.load();
    });
  }

  load(): void {
    this.loading = true;
    this.error = null;
    this.campaignService.getPartnersCamaigns().subscribe({
      next: (res: GenericResponseWithTotal<Camapign>) => {
        this.campaigns = res.items ?? (res as any);
        this.total = res.total ?? this.campaigns.length;
        this.loading = false;
      },
      error: () => {
        this.error = 'Nie udało się załadować kampanii.';
        this.loading = false;
      }
    });
  }
}
